import React from 'react';

export const FileTextIcon = ({
  width = '40',
  height = '40',
  color = '#3966E0', // primary-600
  'aria-hidden': ariaHidden = true,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={ariaHidden}
    {...rest}
  >
    <path
      d="M23.3332 3.33203H9.99984C9.11578 3.33203 8.26794 3.68322 7.64281 4.30834C7.01769 4.93346 6.6665 5.78131 6.6665 6.66536V33.332C6.6665 34.2161 7.01769 35.0639 7.64281 35.6891C8.26794 36.3142 9.11578 36.6654 9.99984 36.6654H29.9998C30.8839 36.6654 31.7317 36.3142 32.3569 35.6891C32.982 35.0639 33.3332 34.2161 33.3332 33.332V13.332M23.3332 3.33203L33.3332 13.332M23.3332 3.33203V13.332H33.3332M26.6665 21.6654H13.3332M26.6665 28.332H13.3332M16.6665 14.9987H13.3332"
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
